// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
import { smoothScrollTo } from 'utilities/scroll'
import ArrowUp from 'components/svg/arrows/arrow-up.svg'
import LongArrowL from 'components/svg/arrows/long-arrow-left.svg'
import LongArrowR from 'components/svg/arrows/long-arrow-right.svg'

class PageNavFooter extends React.Component {
	handleClick = ( e ) => {
		e.currentTarget.blur()
	}

	render() {
		const { page, match, mobile, footerNav } = this.props

		if ( ! page ) {
			return null
		}

		let prevUrl = '',
			nextUrl = ''

		if ( page.prev_post_slug ) {
			prevUrl = match.path.replace( ':slug', page.prev_post_slug )
		}

		if ( page.next_post_slug ) {
			nextUrl = match.path.replace( ':slug', page.next_post_slug )
		}

		return (
			<div className="page-nav-footer">
				<div className="-items">
					{ prevUrl &&
						<Link className="-item" to={ prevUrl } transitionType="leftToRight" onClick={ this.handleClick }>
							{ page.prev_post_featured_image.url &&
								<div className="-image">
									<img src={ page.prev_post_featured_image.url } alt="" />
								</div>
							}

							<div className="-text-wrap">
								<span className="-cat subtitle">{ page.prev_post_category.primary.name }</span>
								<h3 dangerouslySetInnerHTML={ { __html: page.prev_post_title } }></h3>
							</div>
						</Link>
					}

					{ nextUrl &&
						<Link className="-item" to={ nextUrl } transitionType="rightToLeft" onClick={ this.handleClick }>
							{ page.next_post_featured_image.url &&
								<div className="-image">
									<img src={ page.next_post_featured_image.url } alt="" />
								</div>
							}

							<div className="-text-wrap">
								<span className="-cat subtitle">{ page.next_post_category.primary.name }</span>
								<h3 dangerouslySetInnerHTML={ { __html: page.next_post_title } }></h3>
							</div>
						</Link>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( PageNavFooter )



// WEBPACK FOOTER //
// ./components/PageNavFrame/PageNavFooter.jsx